var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 698.323,
    height: 464.603,
    viewBox: "0 0 698.323 464.603",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 397.445,
    height: 6.293,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    d: "M371.1,386.9l.69-.326-3.121-6.622-1.75.823,2.646,5.616A1.078,1.078,0,0,0,371.1,386.9Z",
    transform: "translate(-366.916 -379.951)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-3",
    "data-name": "SVGID",
    d: "M365.37,382.627l6.885-1.285-1.121-5.646-6.831,1.557Z",
    transform: "translate(-364.303 -375.696)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456",
    transform: "translate(-73.173 -101.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M633.22,393.237a85.282,85.282,0,0,0,9.3-21.891l16.453-3.154.17-18.2.169-18.2-16.392-3.458a85.268,85.268,0,0,0-8.886-22.062l9.4-13.852L630.68,279.43l-12.75-12.989-14.025,9.139a85.2,85.2,0,0,0-21.892-9.3l-3.153-16.454-18.2-.17-18.2-.169L539,265.882a85.263,85.263,0,0,0-22.062,8.886l-13.852-9.4L490.1,278.119,477.11,290.869l9.139,14.026a85.1,85.1,0,0,0-9.3,21.892L460.5,329.94l-.169,18.2-.17,18.2,16.393,3.458a85.223,85.223,0,0,0,8.886,22.062l-9.4,13.852,12.75,12.989,12.749,12.991,14.026-9.139a85.267,85.267,0,0,0,21.891,9.3l3.154,16.454,18.2.169,18.2.17,3.458-16.395a85.088,85.088,0,0,0,22.063-8.885l13.852,9.4,12.989-12.749,12.989-12.749ZM527.885,380.325a44.626,44.626,0,1,1,63.108.588A44.628,44.628,0,0,1,527.885,380.325Z",
    transform: "translate(112.187 42.919)",
    fill: "#77a7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M289.175,270.018a63.659,63.659,0,0,0,5.234-16.971l11.982-3.6-1.264-13.531-1.262-13.532-12.441-1.318a63.609,63.609,0,0,0-8.285-15.71l5.924-11.007L278.6,185.676,268.141,177l-9.722,7.859a63.581,63.581,0,0,0-16.971-5.234l-3.6-11.982-13.531,1.263-13.532,1.263-1.318,12.441a63.608,63.608,0,0,0-15.71,8.284l-11.007-5.923-8.676,10.461L165.4,205.892l7.859,9.722a63.611,63.611,0,0,0-5.234,16.971l-11.982,3.6,1.263,13.532,1.263,13.531,12.441,1.318a63.608,63.608,0,0,0,8.285,15.708l-5.924,11.008,10.461,8.676,10.462,8.675,9.721-7.858a63.629,63.629,0,0,0,16.971,5.234l3.6,11.982,13.531-1.263,13.532-1.263,1.318-12.441a63.616,63.616,0,0,0,15.71-8.285l11.007,5.924,8.675-10.461,8.676-10.462Zm-79.229-1.552a33.323,33.323,0,1,1,46.923-4.379A33.322,33.322,0,0,1,209.945,268.467Z",
    transform: "translate(24.024 19.191)",
    fill: "#77a7fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(318.142 229.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M659.7,534.055h-1.142V452.964a32.758,32.758,0,0,0-32.722-32.721H542.409a33.9,33.9,0,0,1-33.864-33.864V234.8a32.759,32.759,0,0,0-32.721-32.721H263.086v-1.142H475.824A33.9,33.9,0,0,1,509.686,234.8V386.38A32.76,32.76,0,0,0,542.409,419.1h83.432A33.9,33.9,0,0,1,659.7,452.964Z",
    transform: "translate(-263.086 -200.941)",
    fill: "#64a4ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(327.365 178.424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M315.542,161.123s12.874,51.271-18.039,65.287-24.992-11.646-24.992-11.646-12.68-3.524,21.828-23.088C310.6,182.455,315.542,161.123,315.542,161.123Z",
    transform: "translate(-270.236 -161.123)",
    fill: "#7bd0a9"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(7.259 4.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M394.869,164.592s6.337,44.691-52.167,64.01-66.836,43.823-66.836,43.823S274.114,173.371,394.869,164.592Z",
    transform: "translate(-275.864 -164.592)",
    fill: "#34b67a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(2.889 52.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M276.584,243.335c-17.348-6.621,23.888-42.126,55.578-41.166s53.166,12.687,74.392,7.73C406.555,209.9,362.012,275.941,276.584,243.335Z",
    transform: "translate(-272.476 -202.15)",
    fill: "#137333"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(221.852 133.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(6.943 103.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M357.672,271.691q1.5-20.217,2.088-37.839c-3.252-1.723-7.161-3.737-10.288-5.221-9.683-4.61-23.173-10.818-31.83-14.79-5.068-2.328-10.033-4.028-10.033-4.028s-34.6-3.316-37.4-3.14c-.885.052-5.21,1.558-10.882,3.721-12.27,4.657-35.922,14.135-39.688,16.84-5.523,3.954-25.285,100.825-25.81,107.4-.513,6.391,26.876,15.134,52.241,21.833-.017,9.821-.215,23.579-.439,36.138-.035,2.146-.075,4.252-.115,6.295H356.5c-.148-2.157-.28-4.285-.388-6.295-.012-.268-.028-.53-.039-.793-.423-8.507-2.078-23.743-1.656-38.581,0,0-.268-15.64,1.285-22.373C355.874,301.129,357.672,271.691,357.672,271.691ZM216.936,328.645c.183-12.61,16.978-36.069,16.978-36.069a6.645,6.645,0,0,1,.787-.3c.012.012.867-.12.867-.108.018,0,2.608-2.47,2.625-2.47.618,2.242,6.18,33.923,7.545,52.366C229.964,338.969,216.845,334.66,216.936,328.645Z",
    transform: "translate(-193.819 -206.666)",
    fill: "#dbd8e3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(126.315 108.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M332.9,391.426c-.731-5.255-1.422-10.506-2.043-15.646,0-.027-.012-.045-.012-.075-.2-1.712-.4-3.4-.6-5.083-.012-.081-.017-.172-.027-.268-.811-7.08-1.485-13.873-1.97-20.091a63.5,63.5,0,0,1,.622-13.975c1.93-31.8,2.888-65.332,2.888-65.332,1.015-13.723,1.6-26.551,1.985-38.506,0,0-43.442-20.531-47.379-21.708,0,0,8.24,19.351,14.42,62.6,2.373,16.611,6.773,44.572,9.97,73.11v.006c1.728,15.4,4.969,31.087,7.434,44.97.377,2.146.738,4.246,1.068,6.295h14.54Q333.331,394.581,332.9,391.426Z",
    transform: "translate(-286.363 -210.741)",
    fill: "#323657"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(0 105.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M288.959,341.119c1.713-16.079,3.253-32.126,2.511-40.918-5.993-70.69-22.945-89.4-25.406-92.14-1.9.725-9.135,3.44-11.252,4.279-11.595,4.571-35.231,12.949-38.415,15.236-5.525,3.955-27.3,105.511-27.956,112.079-.44,4.439,27.978,13.716,56.972,22-.268,7.948.484,19.161-2.158,30.87-.463,2.077-1.147,3.389-1.254,6.135l40.416-.159c.246-2.088.5-4.182.76-6.295.77-6.317,1.575-12.787,2.373-19.663,12.12,3.137,20.36,5.158,20.36,5.158S317.3,358.45,320.6,350.657C321.165,349.327,306.512,345.806,288.959,341.119ZM236.7,316.787c-.383-14.471-.315-24.569-.315-24.569,1.432,4.958,3.412,19.127,5.158,33.21C235.668,322.473,236.771,319.71,236.7,316.787Z",
    transform: "translate(-188.437 -208.061)",
    fill: "#323657"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(81.514 71.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M251.631,214.977s4.4-8.315,3.185-31.921c-.337-6.54,34.353,15.51,34.353,15.51s-.121,2.253-.2,5.3c-.039,1.267-.061,2.653-.061,4.08,0,.393,0,.788,0,1.182.006.645.012,1.283.023,1.923.018.793.046,1.569.085,2.317.041.85.1,1.655.178,2.39a21.836,21.836,0,0,0,1.283,4.635C292.078,224.055,264.619,224.266,251.631,214.977Z",
    transform: "translate(-251.631 -181.843)",
    fill: "#eea987"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(106.592 119.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M275.077,219.17l6.393,8.589s-3.745,5.015-10.4,1.312Z",
    transform: "translate(-271.073 -219.17)",
    fill: "#e8734d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(109.994 128.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M279,226.151s23.421,57.206,18.424,129.87l-7.386,13.407-8.33-11.418s-1.344-96.505-7.994-132.088Z",
    transform: "translate(-273.71 -225.921)",
    fill: "#e8734d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(96.09 109.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M284.283,213.511l-6.845,8.009s-10.986-2.128-14.211-7.867S284.283,213.511,284.283,213.511Z",
    transform: "translate(-262.931 -211.065)",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(110.596 104.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M282.591,207.528s-.795,6.105-8.414,15.017l8.317,11.174,4.5-23.182Z",
    transform: "translate(-274.177 -207.528)",
    fill: "#c4c1cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(80.079 97.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M254.043,201.836S269.928,219.8,281.035,224.2l-5.166,12.776-25.35-27.965Z",
    transform: "translate(-250.519 -201.836)",
    fill: "#c4c1cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(149.194 127.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M401.807,357.545S380.723,337.1,366.895,333.7c-6.394-1.574-14.814-10.4-22.816-20.774-2.637-3.416-5.224-7-7.685-10.549a.026.026,0,0,1-.006-.015c-9.816-14.173-17.509-27.76-17.509-27.76s-29.016-34-5.731-49.162c0,0,9.979-.215,15.452,2.757,5.628,3.056,17.633,28.111,19.668,32.548s24.086,45.642,25.562,46.568,3.938,4.313,12.761,9.064c10.8,5.816,27.77,22.838,27.77,22.838Z",
    transform: "translate(-304.1 -225.432)",
    fill: "#323657"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(117.475 248.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M307.727,354.2a13.417,13.417,0,0,1-4.208-.8s-2.2-1.414-3.828-2.323a12.693,12.693,0,0,0-1.286-.65,24.555,24.555,0,0,1-7.083-3.374c-2.772-2.113-11.812-10.569-11.812-10.569l5.842-8.98,2.7-8.893s21.073,2.1,23.885,3.767a8.363,8.363,0,0,1,.773.517c2.244,1.646,3.221,3.813,4.3,4.81.393.369,4.064,4.3,3.859,5.891a5.252,5.252,0,0,1-2.747,4.3s-.743,4.306-2.971,6.232c0,0-.558,4-4.008,5.6C311.141,349.73,310.121,353.721,307.727,354.2Z",
    transform: "translate(-279.51 -318.61)",
    fill: "#efaa88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(78.809 11.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M282.862,135.723s38.089-9.181,30.066,39.043-17.16,52.137-40.361,42.523-21.59-40.459-22.973-55.553S270.678,136.427,282.862,135.723Z",
    transform: "translate(-249.534 -135.025)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(82.52 41.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M262.018,162.273c-.566-4.236-8.975-5.668-9.557.7s4.068,17.472,7.235,16.326S262.8,168.114,262.018,162.273Z",
    transform: "translate(-252.411 -158.642)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(75.769 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M252.5,188.9s.764-15.168,6.291-15.723,6.47,5.536,6.47,5.536l5.6.974s-1.961-13.256,3.532-15.658,35.913,6.786,40.294,2.822,1.9-30.874-6.181-34.443-30.355-11.506-46.429-.279c0,0-12.676-1.258-14.4,8.983S248.951,181.36,252.5,188.9Z",
    transform: "translate(-247.177 -126.345)",
    fill: "#16202e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(66.092 235.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M306.785,321.506l-15.727,27.039s-41.662-10.734-51.383-13.477L261.9,308.619S294.66,316.1,306.785,321.506Z",
    transform: "translate(-239.675 -308.619)",
    fill: "#323657"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(90.553 85.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M286.992,210.281h-.005c-20.428-2.083-28.348-17.81-28.348-17.81a42.233,42.233,0,0,0,28.241,12.388c0,.393,0,.788,0,1.182.006.645.012,1.283.023,1.923C286.925,208.757,286.954,209.533,286.992,210.281Z",
    transform: "translate(-258.639 -192.471)",
    fill: "#a77860"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(611.695 473.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M501.846,392.638a6.218,6.218,0,0,0-10.855,1.745h0a6.214,6.214,0,0,0,5.318,8.182c.161.014.325.025.49.026.1,0,.206,0,.308-.007h.108a6.218,6.218,0,0,0,5.879-6.127A6.188,6.188,0,0,0,501.846,392.638Zm-3.374,8.119h0a4.635,4.635,0,0,1-1.336.272h0c-.1.005-.208.006-.312.006a4.708,4.708,0,0,1-2.793-.976,4.84,4.84,0,0,1-.464-.411,4.64,4.64,0,0,1-1.223-4.315,4.461,4.461,0,0,1,.125-.451,4.66,4.66,0,1,1,6.006,5.874Z",
    transform: "translate(-490.665 -390.163)",
    fill: "#4da8f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(384.617 336.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M314.621,306.44c23.68,24.375,54.964,55.07,54.964,55.07l12.228-23.216s-27.787-32.574-46.624-54.311C329.415,286.814,318.815,293.57,314.621,306.44Z",
    transform: "translate(-314.621 -283.983)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(367.083 392.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M303.937,326.8s6.376,3.08,8.04,4.451,8.408,6.422,10.043,7.61-2.465,4.566-14.524-.656S303.937,326.8,303.937,326.8Z",
    transform: "translate(-301.027 -326.801)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(359.439 322.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M306.212,272.716l-11.11,103.3H441.344l11.11-103.3Z",
    transform: "translate(-295.102 -272.716)",
    fill: "#fbcb43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(366.641 316.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M448.074,372.577H300.685l11.233-104.442h147.39Zm-146.12-1.143h145.1l10.987-102.158H312.943Z",
    transform: "translate(-300.685 -268.135)",
    fill: "#ffc955"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(347.801 416.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 24.425,
    height: 9.294,
    transform: "translate(24.425 9.294) rotate(180)",
    fill: "#ffc955"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(112.824 425.454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M103.912,352.634v0Z",
    transform: "translate(-103.912 -352.634)",
    fill: "#96cbff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 6.115,
    height: 6.293,
    fill: "#96cbff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 6.114,
    height: 6.293,
    transform: "translate(6.115)",
    fill: "#95caff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 6.114,
    height: 6.293,
    transform: "translate(12.229)",
    fill: "#94c9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 6.115,
    height: 6.293,
    transform: "translate(18.343)",
    fill: "#93c9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 6.114,
    height: 6.293,
    transform: "translate(24.458)",
    fill: "#92c8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 6.115,
    height: 6.293,
    transform: "translate(30.572)",
    fill: "#91c7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 6.114,
    height: 6.293,
    transform: "translate(36.687)",
    fill: "#90c6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 6.114,
    height: 6.293,
    transform: "translate(42.801)",
    fill: "#8fc6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 6.116,
    height: 6.293,
    transform: "translate(48.915)",
    fill: "#8ec5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 6.115,
    height: 6.293,
    transform: "translate(55.031)",
    fill: "#8dc4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 6.114,
    height: 6.293,
    transform: "translate(61.146)",
    fill: "#8cc3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 6.114,
    height: 6.293,
    transform: "translate(67.26)",
    fill: "#8bc2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 6.115,
    height: 6.293,
    transform: "translate(73.374)",
    fill: "#8ac2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 6.114,
    height: 6.293,
    transform: "translate(79.489)",
    fill: "#89c1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 6.114,
    height: 6.293,
    transform: "translate(85.603)",
    fill: "#88c0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 6.115,
    height: 6.293,
    transform: "translate(91.718)",
    fill: "#87bfff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 6.114,
    height: 6.293,
    transform: "translate(97.832)",
    fill: "#86bfff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 6.114,
    height: 6.293,
    transform: "translate(103.947)",
    fill: "#85beff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 6.115,
    height: 6.293,
    transform: "translate(110.061)",
    fill: "#84bdff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 6.116,
    height: 6.293,
    transform: "translate(116.175)",
    fill: "#83bcff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 6.114,
    height: 6.293,
    transform: "translate(122.291)",
    fill: "#82bbff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 6.115,
    height: 6.293,
    transform: "translate(128.406)",
    fill: "#81bbff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 6.114,
    height: 6.293,
    transform: "translate(134.52)",
    fill: "#80baff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 6.114,
    height: 6.293,
    transform: "translate(140.634)",
    fill: "#7fb9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 6.115,
    height: 6.293,
    transform: "translate(146.749)",
    fill: "#7eb8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 6.114,
    height: 6.293,
    transform: "translate(152.863)",
    fill: "#7db7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 6.114,
    height: 6.293,
    transform: "translate(158.978)",
    fill: "#7cb7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 6.115,
    height: 6.293,
    transform: "translate(165.092)",
    fill: "#7bb6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 6.114,
    height: 6.293,
    transform: "translate(171.207)",
    fill: "#7ab5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 6.114,
    height: 6.293,
    transform: "translate(177.321)",
    fill: "#79b4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 6.116,
    height: 6.293,
    transform: "translate(183.435)",
    fill: "#78b4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 6.115,
    height: 6.293,
    transform: "translate(189.551)",
    fill: "#77b3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 6.114,
    height: 6.293,
    transform: "translate(195.666)",
    fill: "#76b2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 6.114,
    height: 6.293,
    transform: "translate(201.78)",
    fill: "#74b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 6.115,
    height: 6.293,
    transform: "translate(207.894)",
    fill: "#73b0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 6.114,
    height: 6.293,
    transform: "translate(214.009)",
    fill: "#72b0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 6.114,
    height: 6.293,
    transform: "translate(220.123)",
    fill: "#71afff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 6.115,
    height: 6.293,
    transform: "translate(226.238)",
    fill: "#70aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 6.114,
    height: 6.293,
    transform: "translate(232.352)",
    fill: "#6fadff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 6.114,
    height: 6.293,
    transform: "translate(238.466)",
    fill: "#6eadff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 6.116,
    height: 6.293,
    transform: "translate(244.581)",
    fill: "#6dacff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 6.114,
    height: 6.293,
    transform: "translate(250.697)",
    fill: "#6cabff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 6.114,
    height: 6.293,
    transform: "translate(256.811)",
    fill: "#6baaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 6.115,
    height: 6.293,
    transform: "translate(262.925)",
    fill: "#6aa9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 6.114,
    height: 6.293,
    transform: "translate(269.04)",
    fill: "#69a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 6.114,
    height: 6.293,
    transform: "translate(275.154)",
    fill: "#68a8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 6.114,
    height: 6.293,
    transform: "translate(281.269)",
    fill: "#67a7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 6.114,
    height: 6.293,
    transform: "translate(287.383)",
    fill: "#66a6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 6.114,
    height: 6.293,
    transform: "translate(293.498)",
    fill: "#65a6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 6.115,
    height: 6.293,
    transform: "translate(299.612)",
    fill: "#64a5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 6.114,
    height: 6.293,
    transform: "translate(305.727)",
    fill: "#63a4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 6.116,
    height: 6.293,
    transform: "translate(311.841)",
    fill: "#62a3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 6.114,
    height: 6.293,
    transform: "translate(317.957)",
    fill: "#61a2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 6.115,
    height: 6.293,
    transform: "translate(324.071)",
    fill: "#60a2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 6.114,
    height: 6.293,
    transform: "translate(330.185)",
    fill: "#5fa1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 6.115,
    height: 6.293,
    transform: "translate(336.3)",
    fill: "#5ea0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 6.114,
    height: 6.293,
    transform: "translate(342.414)",
    fill: "#5d9fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 6.114,
    height: 6.293,
    transform: "translate(348.529)",
    fill: "#5c9eff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 6.115,
    height: 6.293,
    transform: "translate(354.643)",
    fill: "#5b9eff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 6.114,
    height: 6.293,
    transform: "translate(360.758)",
    fill: "#5a9dff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 6.114,
    height: 6.293,
    transform: "translate(366.872)",
    fill: "#599cff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 6.115,
    height: 6.293,
    transform: "translate(372.986)",
    fill: "#589bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 6.116,
    height: 6.293,
    transform: "translate(379.101)",
    fill: "#579bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 6.114,
    height: 6.293,
    transform: "translate(385.217)",
    fill: "#569aff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 6.114,
    height: 6.293,
    transform: "translate(391.331)",
    fill: "#59f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M412.033,358.927v0Z",
    transform: "translate(-14.588 -352.634)",
    fill: "#59f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(408.792 559.753)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 344.353,
    height: 6.295,
    fill: "#ffc955"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(429.718 363.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M349.862,313.47c-1.175,5.75,1.508,11.158,5.994,12.073s9.073-3,10.248-8.756-1.508-11.158-5.993-12.074S351.039,307.717,349.862,313.47Z",
    transform: "translate(-349.586 -304.581)",
    fill: "#cfa345"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(703.319 328.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M567.285,280.363s3.373,5.718,4.8,6.652c1.932,1.268.722,2.55-.2,2.55s-5.609.338-6.64-.836-1.547-4.685-2.508-5.6-1.953-4.573.468-5.461C565.348,276.879,567.285,280.363,567.285,280.363Z",
    transform: "translate(-561.696 -277.548)",
    fill: "#6069a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(704.666 328.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M565.521,277.82s3.863,6.7,4.53,7.688-1.254.987-2.444.516-4.181-5.272-4.611-6.146a3.225,3.225,0,0,1-.092-2.24Z",
    transform: "translate(-562.741 -277.637)",
    fill: "#202338"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(703.532 332.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M561.862,280.573l.892,6.866.472.02-.147-4.939Z",
    transform: "translate(-561.862 -280.573)",
    fill: "#6069a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(669.854 328.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M541.353,280.358s3.373,5.718,4.8,6.652c1.934,1.268.721,2.55-.2,2.55s-5.606.338-6.639-.836-1.545-4.685-2.506-5.6-1.986-4.668.467-5.461C539.428,276.963,541.353,280.358,541.353,280.358Z",
    transform: "translate(-535.753 -277.564)",
    fill: "#6069a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(671.215 328.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M539.789,277.834s3.661,6.683,4.326,7.674-1.254.987-2.443.516-4.182-5.272-4.611-6.146a3.233,3.233,0,0,1-.092-2.24Z",
    transform: "translate(-536.807 -277.637)",
    fill: "#202338"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(670.081 332.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M535.928,280.573l.892,6.866.472.02-.147-4.939Z",
    transform: "translate(-535.928 -280.573)",
    fill: "#6069a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(660.488 274.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M528.491,240.452l30.528,13.91a5.868,5.868,0,0,1,3.788,4.891C564,271.063,572.833,289.8,572.833,289.8c2.835,1.387,2.617.183,2.617.183-1.786-5.732-3.961-29.363-4.736-38.865-.164-2.012-.266-3.39-.288-3.831-.014-.3-.343-.693-.909-1.151-4.188-3.4-21.424-10.429-21.424-10.429C535.151,235.378,528.491,240.452,528.491,240.452Z",
    transform: "translate(-528.491 -235.69)",
    fill: "#202338"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(654.612 272.511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M524.059,246.9c.944,8.252,12.724,7.306,12.724,7.306h14.274a89.2,89.2,0,0,0-5.2,15.382c-1.536,7.469-5.158,20.683-5.158,20.683s.237.449,2.82.2c0,0,11.207-22.335,15.5-27.948.922-1.209,3.568-7.768,4.022-11.68.154-1.317.059-2.333-.432-2.745a35.265,35.265,0,0,0-3.151-2.154c-4.472-2.82-12.236-7.16-16.563-8.133-5.794-1.3-14.96-3.743-14.96-3.743S523.113,238.646,524.059,246.9Z",
    transform: "translate(-523.936 -234.064)",
    fill: "#202338"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(663.068 206.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M531.874,198.229a13.3,13.3,0,0,1-1.1-8.377c1.042-4.32,5.05-8.624,10.919-6.648s10.615,6.537,7.1,11.809,3.183,7.652,1.477,10.161-1.062,5.127-.338,5.712,3.055,2.664,2.8,5.126-11.387-7.177-11.387-7.177S535.28,196.654,531.874,198.229Z",
    transform: "translate(-530.491 -182.71)",
    fill: "#464240"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(658.655 271.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M550.754,235.381s-.885,4.294-23.684-1.127C527.07,234.253,534.713,231.715,550.754,235.381Z",
    transform: "translate(-527.07 -233.397)",
    fill: "#eb4747"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(653.762 232.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M527.91,244.228q-.53,1.012-1.06,2.024l25,.729c-1.318-4.414-.89-10.393-.66-14.931.282-5.541,3.343-9.4,3.017-15,1.648.266,1.934.317,3.585.57-2.524-7.2-3.39-10.76-11.235-13.53a14.661,14.661,0,0,0-7-.853c-9.086.749-11.826.856-16.288,9.089,6.985,1.113,5.834,3.621,7.954,10.571,1.032,3.389,2.11,7.169,1.557,10.744C532.243,237.159,527.91,241.018,527.91,244.228Z",
    transform: "translate(-523.277 -203.148)",
    fill: "#5f8cc9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(669.897 225.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M538.784,207.448c-3.719-.7-2.928-2.769-2.928-2.769s.173-1.169.24-2.643c.017-.378.027-.776.026-1.18a15.818,15.818,0,0,0-.1-1.829c-.3-2.495,6.751-1.007,6.751-1.007s-.408,5.051.565,6.564S542.5,208.15,538.784,207.448Z",
    transform: "translate(-535.785 -197.579)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(665.802 231.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M532.611,203.224s7.5,8.66,10.273,10.667c0,0,3.185-2.879,1.222-10.48C544.105,203.411,540.484,201.6,532.611,203.224Z",
    transform: "translate(-532.611 -202.547)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(664.265 210.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M533.16,187.227s-3.9,7.5-.032,14.613,11.453-3.1,11.944-4.293,3.095-7.969-2.083-10.026S534.262,185.19,533.16,187.227Z",
    transform: "translate(-531.419 -185.831)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(664.119 208.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M534.488,190.24s-2.68,3.521-3,6.123a13.947,13.947,0,0,1,1.949-9.647c3.018-4.726,10.692-.224,11.72,1.664s4.04,3.552-1.02,11.668C544.139,200.048,535.039,193.725,534.488,190.24Z",
    transform: "translate(-531.306 -184.625)",
    fill: "#464240"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(670.207 227.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M539.345,198.823a7.279,7.279,0,0,1-3.319,2.852c.017-.378.027-.776.026-1.18A6.318,6.318,0,0,0,539.345,198.823Z",
    transform: "translate(-536.026 -198.823)",
    fill: "#a77860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(626.431 266.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M509.817,229.819s-1.851.823-2.729.45a8.193,8.193,0,0,0-2.664-.448c-.574,0-2.366-.64-2.335.061s2.91,1.189,3.5,1.407-1.762,1.513-1.981,2.088,2.437,4.351,3.934,3.275,2.309-3.223,2.613-3.359a10.951,10.951,0,0,0,1.124-.74Z",
    transform: "translate(-502.089 -229.555)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(623.812 270.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M504.48,232.26s-4.343,3.6-4.41,4.086.16.713.582.393,4.306-3.355,4.306-3.355-4.351,5.139-4.5,5.521c-.085.223.331.686.575.537s4.869-4.988,4.869-4.988-4.052,4.806-4.075,5.166a.471.471,0,0,0,.8.319c.328-.335,4.361-4.575,4.361-4.575s-2.713,3.689-2.545,4.014c.1.2.445.615,1.113-.359s2.5-3.1,2.5-3.1Z",
    transform: "translate(-500.058 -232.26)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(654.613 272.511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M549.567,254.2H536.782s-11.78.944-12.722-7.307,3.871-12.833,3.871-12.833,6.224,1.658,11.656,2.969a42.024,42.024,0,0,1,9.827-.857s23.027,7.609,22.335,11.616C571.747,247.792,562.115,242.642,549.567,254.2Z",
    transform: "translate(-523.937 -234.064)",
    fill: "#fbcb43"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(671.921 278.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M537.355,238.681l24.377-.358-12.308,6.249Z",
    transform: "translate(-537.355 -238.323)",
    fill: "#5e5853"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(666.973 272.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M546.04,236.7a20.846,20.846,0,0,1-12.206.2l-.315-2.51,13.839.77Z",
    transform: "translate(-533.519 -234.398)",
    fill: "#5f8cc9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(671.921 278.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M549.424,244.492l-12.069-4.675V238.6l13.024,4.7Z",
    transform: "translate(-537.355 -238.601)",
    fill: "#91887f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(632.031 231.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(45.265 0.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M543.635,246.9a1.206,1.206,0,0,0,1.676,1.2l1.416-.6a1.009,1.009,0,0,0,.6-1.087c-.589-3.687-1.855-18.039-.006-20.5a8.975,8.975,0,0,0,1.351-2.406c1.219,3.146,2.737,7.2,3.341,9.378L563.527,248.2l3.861.979a130.447,130.447,0,0,0-8.689-17.762c-.753-2.024-2.915-8.151-4.828-13.607-1.21-3.445-2.319-6.621-2.916-8.33a3.9,3.9,0,0,0-1.683-2.065c-1.784-1.065-4.757-2.746-7.453-4.055l-.032-.015-.258-.124h-.006c5.125,7.755,3.127,29.655,2.114,43.658Z",
    transform: "translate(-541.522 -203.217)",
    fill: "#e57368"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M534.782,204.042c-1.642.254-5.712,4.205-7.873,8.195-2.468,4.552-4.978,9.736-6.861,11.441-3.462,3.136-13.149,14.22-13.61,13.952a29.92,29.92,0,0,0,3.017,3.469c.179.079,15.922-13.563,17.436-15.641,1.434-1.971,5.268-10.24,6.416-10.059l0,.005v0a61.625,61.625,0,0,1,2.8,7.632c.021.072.044.146.065.219a24.516,24.516,0,0,1,.334,10.19c-.373,2.84-2.491,7.48-3.771,9.74a1.536,1.536,0,0,0,.052,1.18h0a.853.853,0,0,0,.42.49l4.623,1.712,1.085.4a2.369,2.369,0,0,0,3.169-1.913c1.028-7.906,2.328-15.983,3.365-19.026a28.822,28.822,0,0,0-1.777-23.383S536.224,203.5,534.782,204.042Z",
    transform: "translate(-506.43 -202.653)",
    fill: "#e57368"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(683.99 264.456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M546.711,247.617l7.251-19.8,23.375.382-6.91,18.243Z",
    transform: "translate(-546.711 -227.82)",
    fill: "#6e6760"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(698.299 271.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M558.226,235.023c-.713,1.427-.5,2.98.481,3.469s2.35-.268,3.063-1.7.5-2.978-.481-3.469S558.939,233.6,558.226,235.023Z",
    transform: "translate(-557.804 -233.18)",
    fill: "#807066"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(672.621 219.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M539.357,192.743s1.5,2.328.112,4.339.349,3.986.649,6.112-5.772,7.781.982,10.626,8.906-1.857,7.183-4.446-2.947-4.688-3.093-8.378S543.829,191.552,539.357,192.743Z",
    transform: "translate(-537.897 -192.583)",
    fill: "#464240"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(641.062 209.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M513.431,185.209h14.094v12.367l-2.152-2.152H513.431Z",
    transform: "translate(-513.431 -185.209)",
    fill: "#ffcb55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(473.794 334.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(68.28 31.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M456.565,306.737s-30.718,29.23-15.776,51.991,21.936,2.824,21.936,2.824,10.106,3.051-4.894-25.011C450.763,323.314,456.565,306.737,456.565,306.737Z",
    transform: "translate(-436.69 -306.737)",
    fill: "#bbd070"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(22.929 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M409.961,282.168s-23.466,27.575,7.907,65.763S444.376,406.3,444.376,406.3,488.048,339.912,409.961,282.168Z",
    transform: "translate(-401.532 -282.168)",
    fill: "#7bd0a9"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(0 33.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M456.6,387.247c14.6,2.951,2.786-39.5-19.107-52.44s-41.478-14.2-53.741-26.667C383.756,308.14,384.712,372.708,456.6,387.247Z",
    transform: "translate(-383.756 -308.14)",
    fill: "#137333"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(416.024 441.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(35.207 20.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M366.264,384.691s.669-1.657.779-1.909a4.339,4.339,0,0,1,1.535-1.06,4.992,4.992,0,0,1,2.149-.525.765.765,0,0,1,.471.436,1.475,1.475,0,0,1,.123.738.9.9,0,0,1,.319.807.782.782,0,0,1,.178.851.655.655,0,0,1,.181.7,5.936,5.936,0,0,0-.84.631,12.472,12.472,0,0,1-3.049,1.5S366.566,386.891,366.264,384.691Z",
    transform: "translate(-366.264 -381.181)",
    fill: "#eea886"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(37.468 22.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M368.129,383.2a4.407,4.407,0,0,1-.107,1.151c-.123.257,1.821.82,1.821.82S369.221,383.21,368.129,383.2Z",
    transform: "translate(-368.017 -383.201)",
    fill: "#cf8c6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(1.313 108.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M339.988,451.841l.849-2.644,3.59.581-.536,2.385Z",
    transform: "translate(-339.988 -449.197)",
    fill: "#3b3f66"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(30.748 108.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M362.807,451.313l.2,1.452,3.93-.655-.209-2.17Z",
    transform: "translate(-362.807 -449.94)",
    fill: "#555c94"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(1.36 57.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M360.9,422.107s-.578,3.155-1.25,6.657c-.117.61-.236,1.231-.357,1.847-.656,3.374-1.319,6.621-1.566,7.292-.556,1.527-12.593,23.583-12.593,23.583s-4.923-.375-5.107-1.007c0,0,10.091-23.95,10.033-24.823s1.233-25.424,1.233-25.424S360.631,420.689,360.9,422.107Z",
    transform: "translate(-340.024 -410.232)",
    fill: "#354c70"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(12.535 53.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M363.886,409.718S368.6,433.837,369,435.683s2.186,26.553,2.186,26.553-1.058,2.182-4.967,1.362c0,0-5.331-26.545-5.781-27.436-1.743-3.452-10.3-20.175-11.131-22.562a14.374,14.374,0,0,1-.586-5.173S355.08,404.855,363.886,409.718Z",
    transform: "translate(-348.687 -407.163)",
    fill: "#354c70"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(23.383 22.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M359.469,385.4s2.065,5.149,2.585,5,6.456-7.124,6.456-7.124,2.715,3.39,2.351,3.779c-.507.541-7.517,12.2-8.482,11.987s-5.276-7.336-5.276-7.336S356.858,386.335,359.469,385.4Z",
    transform: "translate(-357.097 -383.278)",
    fill: "#deb135"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(11.32 15.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M353.344,377.3a86.246,86.246,0,0,1,6.837,5.719c1.478,1.624,5.56,8.359,5.264,10.385a147.032,147.032,0,0,0-1.7,19.685c-.031,4.616,1.441,5.8.525,5.863-1.053.08-14.532,4.965-16.528,5.559,0,0,1.308-16.257,1.971-18.132S347.6,384.849,353.344,377.3Z",
    transform: "translate(-347.745 -377.302)",
    fill: "#f2c344"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(38.079 7.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M381.833,371.282l1.2,6.055,1.2,6.056a32.988,32.988,0,0,0-14.683-.6l-.53-2.671-.534-2.687A33.139,33.139,0,0,0,381.833,371.282Z",
    transform: "translate(-368.49 -371.282)",
    fill: "#d9d0c4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(30.452 110.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M363.075,452.522s2.967-.574,3.071-.663.74-1.263,1.2-1.059.464,1.63.913,1.873,3.99,2.634,4.424,3.069,3.118.179,3.426.937.332,2.546-3.668,2.126-8.571.228-9.433-.244S362.8,453.674,363.075,452.522Z",
    transform: "translate(-362.577 -450.777)",
    fill: "#84bdff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(0 109.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M340.234,451.435s3.022-.091,3.138-.165.934-1.127,1.354-.851.2,1.683.6,2,3.518,3.238,3.877,3.737,3.048.676,3.23,1.473-.077,2.566-3.96,1.51-8.5-1.146-9.271-1.749S339.779,452.527,340.234,451.435Z",
    transform: "translate(-338.969 -450.372)",
    fill: "#84bdff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235",
    transform: "translate(21.669 57.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M358.828,410.01s.361,1.469.94,1.788-2.7,3.458-2.7,3.458a27.629,27.629,0,0,1-1.3-3.2A20.181,20.181,0,0,1,358.828,410.01Z",
    transform: "translate(-355.768 -410.01)",
    fill: "#eea987"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(10.375 19.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M351.177,382.655s-3.844,18.288-4.159,20.161c-.3,1.772,11.271,18.692,11.271,18.692l3.848-2.282s-9.336-16.975-9.322-17.75,4.481-15.517,4.481-15.517,1.867-3.211-1.445-4.77A3.3,3.3,0,0,0,351.177,382.655Z",
    transform: "translate(-347.013 -380.742)",
    fill: "#ffd255"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(21.326 58.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M361.159,410.989s1.251,6.219,1.174,8.124-7.177-3-6.817-4.892Z",
    transform: "translate(-355.503 -410.989)",
    fill: "#3c5780"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247",
    transform: "translate(16.919 9.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M352.086,378.688s9.758,10.659,9.157,9.477c-2.142-4.213-3.637-4.922-3.608-5.709.024-.6.258-2.354.3-2.941.076-1.117.159-2.024.159-2.024s-4.843-6.806-4.629-4.486S352.086,378.688,352.086,378.688Z",
    transform: "translate(-352.086 -372.522)",
    fill: "#eea886"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(16.46 0.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M361.482,368.006a24.723,24.723,0,0,1,1.361,3.885,15.746,15.746,0,0,0-.053,2.152,30.917,30.917,0,0,1,.765,3.235c-.11.618-1.409.3-1.588,1.313s-1.123,2.924-1.593,2.964c-1.209.1-5.834-1.788-6.128-2.755s-1.97-6.364-2.492-7.391,8.15-6.65,8.939-5.026Z",
    transform: "translate(-351.73 -366.091)",
    fill: "#eea886"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(14.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M350.168,370.528c-.613-2.671,2.459-3,2.459-3s2-2.33,6.786-2.052S363.467,372,363.467,372a17.746,17.746,0,0,0-4.749-.13,22.568,22.568,0,0,0-.021,3.328l-1.8-.161s.2-2.367-.666-2.478-1.157,5.01-2.771,6.139a1.774,1.774,0,0,0-.218-.715h0a20.37,20.37,0,0,1-1.255-2.615A29.379,29.379,0,0,1,350.168,370.528Z",
    transform: "translate(-350.087 -365.452)",
    fill: "#16202e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(18.952 6.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M356.394,371.634a1.371,1.371,0,0,0-2.259-.635c-1.156.854.032,3.9,1.156,3.888S356.871,373.212,356.394,371.634Z",
    transform: "translate(-353.662 -370.603)",
    fill: "#eea886"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(18.707 12.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M353.48,375.289a3.5,3.5,0,0,0,.5,1.183,10.354,10.354,0,0,0,3.582,1.873l-.188,1.892S353.27,378.654,353.48,375.289Z",
    transform: "translate(-353.472 -375.289)",
    fill: "#c48a6f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(36.048 18.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M366.916,379.951v0Z",
    transform: "translate(-366.916 -379.951)",
    fill: "#96cbff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 0.074,
    height: 7.244,
    transform: "translate(0 0)",
    fill: "#96cbff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 0.076,
    height: 7.244,
    transform: "translate(0.075 0)",
    fill: "#95caff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 0.074,
    height: 7.244,
    transform: "translate(0.15 0)",
    fill: "#94c9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 0.076,
    height: 7.244,
    transform: "translate(0.225 0)",
    fill: "#93c9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 0.074,
    height: 7.244,
    transform: "translate(0.3 0)",
    fill: "#92c8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 0.076,
    height: 7.244,
    transform: "translate(0.375 0)",
    fill: "#91c7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 0.074,
    height: 7.244,
    transform: "translate(0.45 0)",
    fill: "#90c6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 0.076,
    height: 7.244,
    transform: "translate(0.524 0)",
    fill: "#8fc6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 0.074,
    height: 7.244,
    transform: "translate(0.6 0)",
    fill: "#8ec5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 0.076,
    height: 7.244,
    transform: "translate(0.674 0)",
    fill: "#8dc4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 0.074,
    height: 7.244,
    transform: "translate(0.75 0)",
    fill: "#8cc3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 0.076,
    height: 7.244,
    transform: "translate(0.824 0)",
    fill: "#8bc2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 0.074,
    height: 7.244,
    transform: "translate(0.9 0)",
    fill: "#8ac2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 0.076,
    height: 7.244,
    transform: "translate(0.974 0)",
    fill: "#89c1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 0.074,
    height: 7.244,
    transform: "translate(1.05 0)",
    fill: "#88c0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 0.076,
    height: 7.244,
    transform: "translate(1.124 0)",
    fill: "#87bfff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 0.074,
    height: 7.244,
    transform: "translate(1.2 0)",
    fill: "#86bfff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 0.074,
    height: 7.244,
    transform: "translate(1.274 0)",
    fill: "#85beff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 0.076,
    height: 7.244,
    transform: "translate(1.348 0)",
    fill: "#84bdff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 0.076,
    height: 7.244,
    transform: "translate(1.424 0)",
    fill: "#83bcff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 0.074,
    height: 7.244,
    transform: "translate(1.499 0)",
    fill: "#82bbff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 0.074,
    height: 7.244,
    transform: "translate(1.574 0)",
    fill: "#81bbff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 0.076,
    height: 7.244,
    transform: "translate(1.648 0)",
    fill: "#80baff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 0.076,
    height: 7.244,
    transform: "translate(1.724 0)",
    fill: "#7fb9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 0.074,
    height: 7.244,
    transform: "translate(1.799 0)",
    fill: "#7eb8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 0.074,
    height: 7.244,
    transform: "translate(1.874 0)",
    fill: "#7db7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 0.076,
    height: 7.244,
    transform: "translate(1.948 0)",
    fill: "#7cb7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 0.076,
    height: 7.244,
    transform: "translate(2.023 0)",
    fill: "#7bb6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 0.074,
    height: 7.244,
    transform: "translate(2.099 0)",
    fill: "#7ab5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 0.074,
    height: 7.244,
    transform: "translate(2.173 0)",
    fill: "#79b4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 0.076,
    height: 7.244,
    transform: "translate(2.248 0)",
    fill: "#78b4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 0.074,
    height: 7.244,
    transform: "translate(2.323 0)",
    fill: "#77b3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 0.076,
    height: 7.244,
    transform: "translate(2.398 0)",
    fill: "#76b2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 0.074,
    height: 7.244,
    transform: "translate(2.473 0)",
    fill: "#74b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 0.076,
    height: 7.244,
    transform: "translate(2.548 0)",
    fill: "#73b0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 0.074,
    height: 7.244,
    transform: "translate(2.623 0)",
    fill: "#72b0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 0.076,
    height: 7.244,
    transform: "translate(2.697 0)",
    fill: "#71afff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 0.074,
    height: 7.244,
    transform: "translate(2.773 0)",
    fill: "#70aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 0.076,
    height: 7.244,
    transform: "translate(2.847 0)",
    fill: "#6fadff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 0.074,
    height: 7.244,
    transform: "translate(2.923 0)",
    fill: "#6eadff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 0.076,
    height: 7.244,
    transform: "translate(2.997 0)",
    fill: "#6dacff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 0.074,
    height: 7.244,
    transform: "translate(3.073 0)",
    fill: "#6cabff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 0.076,
    height: 7.244,
    transform: "translate(3.147 0)",
    fill: "#6baaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 0.074,
    height: 7.244,
    transform: "translate(3.223 0)",
    fill: "#6aa9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 0.076,
    height: 7.244,
    transform: "translate(3.297 0)",
    fill: "#69a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 0.074,
    height: 7.244,
    transform: "translate(3.373 0)",
    fill: "#68a8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 0.076,
    height: 7.244,
    transform: "translate(3.447 0)",
    fill: "#67a7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 0.074,
    height: 7.244,
    transform: "translate(3.522 0)",
    fill: "#66a6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 0.076,
    height: 7.244,
    transform: "translate(3.597 0)",
    fill: "#65a6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 0.074,
    height: 7.244,
    transform: "translate(3.672 0)",
    fill: "#64a5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 0.076,
    height: 7.244,
    transform: "translate(3.747 0)",
    fill: "#63a4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 0.074,
    height: 7.244,
    transform: "translate(3.822 0)",
    fill: "#62a3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 0.076,
    height: 7.244,
    transform: "translate(3.897 0)",
    fill: "#61a2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 0.074,
    height: 7.244,
    transform: "translate(3.972 0)",
    fill: "#60a2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 0.076,
    height: 7.244,
    transform: "translate(4.047 0)",
    fill: "#5fa1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 0.074,
    height: 7.244,
    transform: "translate(4.122 0)",
    fill: "#5ea0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 0.076,
    height: 7.244,
    transform: "translate(4.196 0)",
    fill: "#5d9fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 0.074,
    height: 7.244,
    transform: "translate(4.272 0)",
    fill: "#5c9eff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 0.076,
    height: 7.244,
    transform: "translate(4.346 0)",
    fill: "#5b9eff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 0.074,
    height: 7.244,
    transform: "translate(4.422 0)",
    fill: "#5a9dff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 0.076,
    height: 7.244,
    transform: "translate(4.496 0)",
    fill: "#599cff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 0.074,
    height: 7.244,
    transform: "translate(4.572 0)",
    fill: "#589bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 0.076,
    height: 7.244,
    transform: "translate(4.646 0)",
    fill: "#579bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 0.074,
    height: 7.244,
    transform: "translate(4.722 0)",
    fill: "#569aff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 0.076,
    height: 7.244,
    transform: "translate(4.796 0)",
    fill: "#59f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M370.693,387.2v0Z",
    transform: "translate(-365.821 -379.951)",
    fill: "#59f"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(37.421 20.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M370.021,381.29s-1.954,1.072-1.819,1.408a.565.565,0,0,0,.384.378l-.6.8s-.1.76.757.645c0,0-.165.7.647.491,0,0,.1.51.489.48a7.447,7.447,0,0,0,1.623-.773s.19-.273-.181-.7a.767.767,0,0,0-.178-.851.848.848,0,0,0-.318-.807s.181-.953-.594-1.174C370.229,381.193,370.1,381.244,370.021,381.29Z",
    transform: "translate(-367.98 -381.193)",
    fill: "#db9c7c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(32.678 13.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M364.3,375.7v0Z",
    transform: "translate(-364.303 -375.696)",
    fill: "#96cbff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 0.122,
    height: 6.931,
    fill: "#96cbff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 0.122,
    height: 6.931,
    transform: "translate(0.122)",
    fill: "#95caff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 0.123,
    height: 6.931,
    transform: "translate(0.244)",
    fill: "#94c9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 0.122,
    height: 6.931,
    transform: "translate(0.368)",
    fill: "#93c9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    width: 0.122,
    height: 6.931,
    transform: "translate(0.49)",
    fill: "#92c8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 0.122,
    height: 6.931,
    transform: "translate(0.612)",
    fill: "#91c7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 0.122,
    height: 6.931,
    transform: "translate(0.734)",
    fill: "#90c6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 0.122,
    height: 6.931,
    transform: "translate(0.856)",
    fill: "#8fc6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 0.122,
    height: 6.931,
    transform: "translate(0.979)",
    fill: "#8ec5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 0.122,
    height: 6.931,
    transform: "translate(1.101)",
    fill: "#8dc4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 0.123,
    height: 6.931,
    transform: "translate(1.223)",
    fill: "#8cc3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 0.122,
    height: 6.931,
    transform: "translate(1.347)",
    fill: "#8bc2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 0.122,
    height: 6.931,
    transform: "translate(1.469)",
    fill: "#8ac2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 0.122,
    height: 6.931,
    transform: "translate(1.591)",
    fill: "#89c1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 0.122,
    height: 6.931,
    transform: "translate(1.713)",
    fill: "#88c0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 0.122,
    height: 6.931,
    transform: "translate(1.835)",
    fill: "#87bfff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 0.122,
    height: 6.931,
    transform: "translate(1.957)",
    fill: "#86bfff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 0.122,
    height: 6.931,
    transform: "translate(2.08)",
    fill: "#85beff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 0.123,
    height: 6.931,
    transform: "translate(2.202)",
    fill: "#84bdff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 0.122,
    height: 6.931,
    transform: "translate(2.325)",
    fill: "#83bcff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 0.122,
    height: 6.931,
    transform: "translate(2.447)",
    fill: "#82bbff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 0.122,
    height: 6.931,
    transform: "translate(2.57)",
    fill: "#81bbff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 0.122,
    height: 6.931,
    transform: "translate(2.692)",
    fill: "#80baff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 0.122,
    height: 6.931,
    transform: "translate(2.814)",
    fill: "#7fb9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 0.122,
    height: 6.931,
    transform: "translate(2.936)",
    fill: "#7eb8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 0.122,
    height: 6.931,
    transform: "translate(3.058)",
    fill: "#7db7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 0.122,
    height: 6.931,
    transform: "translate(3.181)",
    fill: "#7cb7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 0.122,
    height: 6.931,
    transform: "translate(3.303)",
    fill: "#7bb6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 0.122,
    height: 6.931,
    transform: "translate(3.425)",
    fill: "#7ab5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 0.123,
    height: 6.931,
    transform: "translate(3.547)",
    fill: "#79b4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 0.122,
    height: 6.931,
    transform: "translate(3.671)",
    fill: "#78b4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 0.122,
    height: 6.931,
    transform: "translate(3.793)",
    fill: "#77b3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 0.122,
    height: 6.931,
    transform: "translate(3.915)",
    fill: "#76b2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 0.122,
    height: 6.931,
    transform: "translate(4.037)",
    fill: "#74b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 0.122,
    height: 6.931,
    transform: "translate(4.159)",
    fill: "#73b0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 0.122,
    height: 6.931,
    transform: "translate(4.282)",
    fill: "#72b0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 0.122,
    height: 6.931,
    transform: "translate(4.404)",
    fill: "#71afff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 0.123,
    height: 6.931,
    transform: "translate(4.526)",
    fill: "#70aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 0.122,
    height: 6.931,
    transform: "translate(4.649)",
    fill: "#6fadff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 0.122,
    height: 6.931,
    transform: "translate(4.772)",
    fill: "#6eadff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 0.122,
    height: 6.931,
    transform: "translate(4.894)",
    fill: "#6dacff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 0.122,
    height: 6.931,
    transform: "translate(5.016)",
    fill: "#6cabff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 0.122,
    height: 6.931,
    transform: "translate(5.138)",
    fill: "#6baaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 0.122,
    height: 6.931,
    transform: "translate(5.26)",
    fill: "#6aa9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 0.122,
    height: 6.931,
    transform: "translate(5.382)",
    fill: "#69a9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 0.122,
    height: 6.931,
    transform: "translate(5.505)",
    fill: "#68a8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 0.123,
    height: 6.931,
    transform: "translate(5.627)",
    fill: "#67a7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 0.122,
    height: 6.931,
    transform: "translate(5.75)",
    fill: "#66a6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 0.122,
    height: 6.931,
    transform: "translate(5.873)",
    fill: "#65a6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 0.122,
    height: 6.931,
    transform: "translate(5.995)",
    fill: "#64a5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 0.122,
    height: 6.931,
    transform: "translate(6.117)",
    fill: "#63a4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 0.122,
    height: 6.931,
    transform: "translate(6.239)",
    fill: "#62a3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 0.122,
    height: 6.931,
    transform: "translate(6.361)",
    fill: "#61a2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 0.122,
    height: 6.931,
    transform: "translate(6.483)",
    fill: "#60a2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 0.123,
    height: 6.931,
    transform: "translate(6.606)",
    fill: "#5fa1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 0.122,
    height: 6.931,
    transform: "translate(6.729)",
    fill: "#5ea0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 0.122,
    height: 6.931,
    transform: "translate(6.851)",
    fill: "#5d9fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 0.122,
    height: 6.931,
    transform: "translate(6.973)",
    fill: "#5c9eff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 0.122,
    height: 6.931,
    transform: "translate(7.096)",
    fill: "#5b9eff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 0.122,
    height: 6.931,
    transform: "translate(7.218)",
    fill: "#5a9dff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 0.122,
    height: 6.931,
    transform: "translate(7.34)",
    fill: "#599cff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 0.122,
    height: 6.931,
    transform: "translate(7.462)",
    fill: "#589bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 0.122,
    height: 6.931,
    transform: "translate(7.584)",
    fill: "#579bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 0.123,
    height: 6.931,
    transform: "translate(7.707)",
    fill: "#569aff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 0.122,
    height: 6.931,
    transform: "translate(7.83)",
    fill: "#59f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M370.468,382.627v0Z",
    transform: "translate(-362.516 -375.696)",
    fill: "#59f"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(35.914 21.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M366.942,382.392a7.6,7.6,0,0,1,2.374.3c.191.077.361.187.361.395s-.3.468-.96.522a5.627,5.627,0,0,0-1.491.422S366.531,383.885,366.942,382.392Z",
    transform: "translate(-366.812 -382.391)",
    fill: "#eea886"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(16.716 67.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M356.2,426.51c-.117.61-.236,1.231-.357,1.847l-3.91-10.349C352.445,419.053,356.2,426.51,356.2,426.51Z",
    transform: "translate(-351.929 -418.008)",
    fill: "#293b57"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(151.923 281.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_231",
    "data-name": "Rectangle 231",
    d: "M6.4,0H71.8a6.4,6.4,0,0,1,6.4,6.4V107.555a6.4,6.4,0,0,1-6.4,6.4H6.4a6.4,6.4,0,0,1-6.4-6.4V6.4A6.4,6.4,0,0,1,6.4,0Z",
    transform: "translate(0 0)",
    fill: "#fbcb43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(160.23 291.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(57.527 63.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 4.052,
    height: 30.833,
    fill: "#e3f2ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(49.523 67.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 4.051,
    height: 27.378,
    fill: "#e3f2ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(40.826 71.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 4.051,
    height: 22.883,
    fill: "#e3f2ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(31.895 77.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 4.051,
    height: 17.216,
    fill: "#e3f2ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(6.843 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M146.847,321.986l-.878-.312,7.64-21.433,16.567-4.381,5.954-23.524,12.786-5.643,2.863-18.292.921.144-2.943,18.794L176.923,273l-5.977,23.614-16.624,4.4Z",
    transform: "translate(-145.969 -248.4)",
    fill: "#e3f2ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    transform: "translate(28.948 45.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M167.519,284.472a2.487,2.487,0,1,1-3.5-.351A2.489,2.489,0,0,1,167.519,284.472Z",
    transform: "translate(-163.106 -283.56)",
    fill: "#ffc955"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(28.483 44.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M167.566,288.436a2.953,2.953,0,1,1,.417-4.154A2.954,2.954,0,0,1,167.566,288.436Zm-3.147-3.849a2.02,2.02,0,1,0,2.842.286A2.02,2.02,0,0,0,164.419,284.587Z",
    transform: "translate(-162.746 -283.199)",
    fill: "#e3f2ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(34.981 21.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M172.194,266.31a2.486,2.486,0,1,1-3.5-.351A2.485,2.485,0,0,1,172.194,266.31Z",
    transform: "translate(-167.784 -265.398)",
    fill: "#ffc955"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(34.516 21.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M172.242,270.275a2.953,2.953,0,1,1,.418-4.156A2.956,2.956,0,0,1,172.242,270.275Zm-3.146-3.85a2.02,2.02,0,1,0,2.842.285A2.02,2.02,0,0,0,169.1,266.425Z",
    transform: "translate(-167.423 -265.037)",
    fill: "#e3f2ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    transform: "translate(47.569 16.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M181.953,261.811a2.486,2.486,0,1,1-3.5-.351A2.486,2.486,0,0,1,181.953,261.811Z",
    transform: "translate(-177.543 -260.899)",
    fill: "#ffc955"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(47.105 15.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M182,265.775a2.952,2.952,0,1,1,.418-4.155A2.955,2.955,0,0,1,182,265.775Zm-3.146-3.85a2.02,2.02,0,1,0,2.843.286A2.023,2.023,0,0,0,178.855,261.925Z",
    transform: "translate(-177.182 -260.538)",
    fill: "#e3f2ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(12.445 49.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M154.725,288.04a2.487,2.487,0,1,1-3.5-.352A2.484,2.484,0,0,1,154.725,288.04Z",
    transform: "translate(-150.312 -287.127)",
    fill: "#ffc955"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(11.981 49.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M154.772,292a2.953,2.953,0,1,1,.417-4.156A2.955,2.955,0,0,1,154.772,292Zm-3.147-3.85a2.02,2.02,0,1,0,2.842.285A2.02,2.02,0,0,0,151.625,288.154Z",
    transform: "translate(-149.952 -286.766)",
    fill: "#e3f2ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(0 22.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    d: "M1.383,0H23.508a1.383,1.383,0,0,1,1.383,1.383v2.39a1.383,1.383,0,0,1-1.383,1.383H1.384A1.384,1.384,0,0,1,0,3.773V1.383A1.383,1.383,0,0,1,1.383,0Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(0 13.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    d: "M1.383,0H23.508a1.383,1.383,0,0,1,1.383,1.383v2.39a1.384,1.384,0,0,1-1.384,1.384H1.384A1.384,1.384,0,0,1,0,3.773V1.383A1.383,1.383,0,0,1,1.383,0Z",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    transform: "translate(114.655 313.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(23.919 8.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M127.666,272.961s-.722,7.118.593,8.9c0,0-3.481-.758-4.288-1.957S127.666,272.961,127.666,272.961Z",
    transform: "translate(-123.875 -272.961)",
    fill: "#16202e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(48.993 30.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M143.769,290.821s1.264-.85,1.46-.973a3.669,3.669,0,0,1,1.589-.016,4.227,4.227,0,0,1,1.765.656.646.646,0,0,1,.124.531,1.267,1.267,0,0,1-.267.579.763.763,0,0,1-.161.72.668.668,0,0,1-.281.686.556.556,0,0,1-.206.579,4.959,4.959,0,0,0-.893.043,10.611,10.611,0,0,1-2.867-.4S142.61,292.925,143.769,290.821Z",
    transform: "translate(-143.314 -289.761)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(50.994 32.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M145.47,291.039a3.753,3.753,0,0,1-.582.8c-.2.131.973,1.394.973,1.394S146.264,291.524,145.47,291.039Z",
    transform: "translate(-144.865 -291.039)",
    fill: "#cf8c6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(47.71 31.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M143.309,290.751a5.146,5.146,0,0,0,1.286-.315c.49-.227-.092,2.474-.092,2.474a5.061,5.061,0,0,0-1.966-.844C141.76,292.041,143.309,290.751,143.309,290.751Z",
    transform: "translate(-142.32 -290.422)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(12.522 103.495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M118.293,346.461a44.95,44.95,0,0,0,3.35,4.4s1.734.9,1.786,1.618c.1,1.36.174,2.159-2.106,2.224s-3.7-.006-4.123-1.388a10.389,10.389,0,0,0-1.138-2.465l-.173,3.594h-.515s-.23-3.6-.262-4.116-.369-2.488.716-3.364A3.009,3.009,0,0,1,118.293,346.461Z",
    transform: "translate(-115.04 -346.384)",
    fill: "#162d40"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(13.076 102.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M121.849,351.261a5.744,5.744,0,0,1-2.7-.021c-1.467-.369-2.874-3.879-3.3-4.172l-.381-1.416h2.858a5.074,5.074,0,0,0,.485,1.945A34.063,34.063,0,0,0,121.849,351.261Z",
    transform: "translate(-115.469 -345.653)",
    fill: "#162d40"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    transform: "translate(28.067 101.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M130.925,345.556a9.218,9.218,0,0,0,1.076,1.8c.516.672,2.119,3.436,2.826,3.629s2.889.578,3.083,1.8.288,2.087-1.864,2.184-3.563.224-4.591-1.285a11.209,11.209,0,0,0-2.665-2.6v3.938h-.836a35.464,35.464,0,0,0-.61-4.386c-.223-.29-.8-3.436,1.188-5.074S130.925,345.556,130.925,345.556Z",
    transform: "translate(-127.091 -344.828)",
    fill: "#162d40"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(29.056 101.783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M134.6,350.916s-1.927.481-2.665,0-3.251-4.725-4.081-4.979c0,0,.806-1.636,2.844-.448C130.7,345.489,134.057,350.209,134.6,350.916Z",
    transform: "translate(-127.858 -345.057)",
    fill: "#162d40"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345",
    transform: "translate(10.135 42.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M117.736,299.931a20.179,20.179,0,0,0-3.454,7.724c-.737,4.19.436,18.253.4,20.325s-1.827,8.516-1.442,12.417,2.4,20.187,2.4,20.187l4.707-.086s-.943-17.571-.7-19.208,1.007-8.6,1.1-9.281,5.362-18.505,5.362-21.526S124.286,295,117.736,299.931Z",
    transform: "translate(-113.189 -298.791)",
    fill: "#1d3b54"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(18.988 43.743)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M129.393,300.946s4.463,17.033,4.992,19.394,1.59,5.442,1.543,5.875-.562,7.706-.562,7.706L134.1,358.678h-4.7s-1.509-15.751-1.75-18.928,1.735-8.093,1.253-9.442-7.755-16.9-7.755-16.9S115.634,296,129.393,300.946Z",
    transform: "translate(-120.052 -300.061)",
    fill: "#1d3b54"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349",
    transform: "translate(25.376 19.13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M126.576,280.98a5.409,5.409,0,0,1,3.134,1.614,20.669,20.669,0,0,1,2.967,4.52c.353.771,5.305,7.914,5.562,8.073s2.42-.409,4.155-.553a38.02,38.02,0,0,0,7.061-1.677l.629,3.2s-10.411,3.358-12.813,2.767c-2.937-.724-9.7-9.4-9.7-9.4S122.531,283.614,126.576,280.98Z",
    transform: "translate(-125.005 -280.98)",
    fill: "#e57368"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351",
    transform: "translate(11.442 17.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M126.594,280.037a24.126,24.126,0,0,0,3.114,1.251c.8.161,3.917,4.208,4.464,5.685s0,3.693-1.124,6.292-.064,3.47-.578,6.07a72.564,72.564,0,0,0-.418,11.136c.1,1.445-14.865,4.17-17.851,1.538,0,0,2.021-6.665,4.415-9.167.517-.542.463-4.15.11-5.047s-4.335-7.61-4.335-7.61-.293-6.807,1.445-8.156c1.509-1.171,5.623-1.591,6.362-1.846A12.562,12.562,0,0,1,126.594,280.037Z",
    transform: "translate(-114.202 -279.916)",
    fill: "#e57368"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    transform: "translate(24.504 17.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M124.4,285.348l1.4-1.645-1.219-4.331A28.585,28.585,0,0,0,124.4,285.348Z",
    transform: "translate(-124.329 -279.372)",
    fill: "#d1c0ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355",
    transform: "translate(6.123 19.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M119.721,281a4.028,4.028,0,0,0-4.584,2.377c-1.669,3.211-1.251,4.944-1.637,6.389s-1.926,11.11-2.023,11.528-1.572,5.331-1.381,6.839,1.575,12.94,1.51,13.326,2.664-.369,2.664-.369-.112-11.672-.014-12.636.191-6.02.915-7.321,2.5-9.247,2.889-10.065S122.177,282.047,119.721,281Z",
    transform: "translate(-110.079 -280.905)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(19.438 12.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M125.9,278.652a55.44,55.44,0,0,0-.365,5.623s-2.4,2.408-5.134-2.809a7.166,7.166,0,0,0,.284-5.081C119.819,273.454,125.9,278.652,125.9,278.652Z",
    transform: "translate(-120.401 -275.489)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359",
    transform: "translate(21.989 20.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M124.962,282.32v2.2l-2.582-2.289Z",
    transform: "translate(-122.379 -282.231)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    transform: "translate(18.108 17.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M125.834,285.191l-1.148-1.421-3.867-3.854-1.449.644Z",
    transform: "translate(-119.37 -279.916)",
    fill: "#d1c0ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    transform: "translate(24.757 17.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M125.744,283.7l1.771.489-2.991-4.82Z",
    transform: "translate(-124.525 -279.372)",
    fill: "#fae6de"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(18.049 17.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M124.7,283.83l-1.617,2.591-3.757-5.894,1.61-.819Z",
    transform: "translate(-119.325 -279.708)",
    fill: "#fae6de"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(30.457 25.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M130.147,292.4a19.661,19.661,0,0,0-.036-6.185s-.34,1.887-1.167,4.827Z",
    transform: "translate(-128.944 -286.214)",
    fill: "#cf645a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(13.703 25.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M115.955,291.867s1.6-5.289,1.694-5.578a44.84,44.84,0,0,1-.722,7.265S116.338,292.528,115.955,291.867Z",
    transform: "translate(-115.955 -286.289)",
    fill: "#d1685e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(48.09 5.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M167.77,270.066l-25.157,31.7.877.676Z",
    transform: "translate(-142.614 -270.066)",
    fill: "#54281a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(51.256 31.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M147.88,290.313s-1.887-.177-1.953.124a.483.483,0,0,0,.092.451l-.811.279s-.432.488.226.817c0,0-.45.414.223.655,0,0-.177.405.116.571a6.331,6.331,0,0,0,1.51.231s.264-.1.206-.579a.655.655,0,0,0,.281-.686.716.716,0,0,0,.161-.72s.583-.587.143-1.111A1.728,1.728,0,0,0,147.88,290.313Z",
    transform: "translate(-145.068 -290.261)",
    fill: "#db9c7c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(50.299 30.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M145,289.828a6.479,6.479,0,0,1,1.53,1.344c.1.147.164.306.066.45s-.436.188-.925-.089a4.74,4.74,0,0,0-1.254-.415S143.993,290.684,145,289.828Z",
    transform: "translate(-144.326 -289.828)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373",
    transform: "translate(18.049 0.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M124.264,266.751s4.255-.111,5.038,4.927-1.027,9.466-1.736,10.176-4.965.172-5.968-2.446-2.471-4.525-2.251-6.776S119.03,266.665,124.264,266.751Z",
    transform: "translate(-119.325 -266.75)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(15.312 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M130.1,273.761s1.14-6.286-4.511-7.411-7.631,2.74-8.169,5.038.1,8.782.1,8.782,3.765,3.3,6.016,4.159c0,0-1.883-6.9-1.175-11.84,0,0,4.592.721,7.64-.03C130,272.459,130.092,273.49,130.1,273.761Z",
    transform: "translate(-117.202 -266.149)",
    fill: "#16202e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    transform: "translate(21.352 14.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M125.373,278.971a7.187,7.187,0,0,1-3.488-1.317,8.294,8.294,0,0,0,3.386,2.428S125.388,279.2,125.373,278.971Z",
    transform: "translate(-121.885 -277.654)",
    fill: "#a77860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    transform: "translate(0 48.61)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 16.656,
    height: 12.318,
    transform: "matrix(0.987, -0.161, 0.161, 0.987, 0, 2.684)",
    fill: "#366e9c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    transform: "translate(6.541 57.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M110.945,316.543a2.2,2.2,0,0,1-.281-.656s-.01-.437-.036-.748a1.765,1.765,0,0,0-.03-.237,4.121,4.121,0,0,1-.191-1.3,27.557,27.557,0,0,1,.827-3.047l1.455.05,1.37-.148a27.6,27.6,0,0,1,1.683,3.7,1.257,1.257,0,0,1,0,.156,5.082,5.082,0,0,1-.266,1.042c-.014.09-.217.962-.455,1.084a.88.88,0,0,1-.851.019,2.108,2.108,0,0,1-1.14.17,1.3,1.3,0,0,1-1.149-.036S111.233,316.829,110.945,316.543Z",
    transform: "translate(-110.402 -310.461)",
    fill: "#eea886"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    transform: "translate(6.138 19.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M119.718,281a4.028,4.028,0,0,0-4.584,2.377,14.683,14.683,0,0,0-1.885,6.148c-.21,1.482-2.246,10.275-2.342,10.693s-.766,5.914-.814,7.915c-.035,1.522.321,11.5.257,11.881s4.611-.675,4.611-.675-.517-9.2-.421-10.162.3-5.766.773-7.178c.553-1.656,2.736-10.008,3.122-10.829S122.174,282.047,119.718,281Z",
    transform: "translate(-110.09 -280.905)",
    fill: "#e57368"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(232.544 308.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    transform: "translate(44.335 108.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M235.241,348.639l.3-2.822s-3.981-.03-4.446.306c0,0,.339,2.371.381,2.727S235.241,348.639,235.241,348.639Z",
    transform: "translate(-231.097 -345.816)",
    fill: "#5c544d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389",
    transform: "translate(38.218 110.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M229.851,353.964c4.737-.041,7.02.283,7.528-.485s-.735-5.67-.735-5.67a9.9,9.9,0,0,1-3.83.161,10.054,10.054,0,0,1-2.319,2.052c-1.142.622-2.935.869-3.608,1.513C226.4,352,225.114,354,229.851,353.964Z",
    transform: "translate(-226.355 -347.809)",
    fill: "#3c4145"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(17.67 108.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M214.569,348.639l.3-2.822s-3.981-.03-4.445.306c0,0,.338,2.371.381,2.727S214.569,348.639,214.569,348.639Z",
    transform: "translate(-210.425 -345.816)",
    fill: "#5c544d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(9.365 110.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M209.669,353.964c4.735-.125,7.02.283,7.528-.485s-.735-5.67-.735-5.67a9,9,0,0,1-3.828.161,10.074,10.074,0,0,1-2.321,2.052c-1.14.622-5.338,1.134-6.011,1.779C203.814,352.266,203.006,354.139,209.669,353.964Z",
    transform: "translate(-203.987 -347.809)",
    fill: "#3c4145"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    transform: "translate(32.715 47.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M232.388,298.6a35.076,35.076,0,0,1,1.719,10.954c-.262,5.069,1.024,10.618,1.549,15.915.586,5.9,2.982,19.883,3.07,23.042s-.373,13.243-.373,13.243l-4.8.112s-4.03-24.438-5.073-26.932-6.219-20.272-6.393-22.266S232.388,298.6,232.388,298.6Z",
    transform: "translate(-222.088 -298.6)",
    fill: "#dbd8e3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397",
    transform: "translate(17.021 46.724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M215.746,299.8s-2.635,13.9-2.984,17-.579,15.018-.753,16.957-1.16,25.381-2.087,28.263h6.133s4.707-17.042,4.707-25.1,3.639-17.527,5.986-22.847,7.721-5.446,9.166-15.315C235.915,298.753,217.7,296.669,215.746,299.8Z",
    transform: "translate(-209.922 -298.073)",
    fill: "#dbd8e3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399",
    transform: "translate(26.7 0.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M226.035,262.693s-4.835-1.806-7.063,1.874-2.013,11.048.422,11.953,6.1.432,7.346-1.87a18.425,18.425,0,0,0,2.32-7.857A4.848,4.848,0,0,0,226.035,262.693Z",
    transform: "translate(-217.425 -262.249)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(29.341 10.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M219.611,274.139a4.043,4.043,0,0,1-.126,1.892c-.323.623,6.082.64,6.082.64a42,42,0,0,1,1.505-6.264C228.056,267.539,219.611,274.139,219.611,274.139Z",
    transform: "translate(-219.473 -269.685)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403",
    transform: "translate(27.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M227.539,272.678s-.442.729-2.247.445-4.005-2.683-4.758-2.946-.76-.706-.76-.706l-.472.689-.8.05s.729-2.146-.371-3.024,1.142-6.949,6.929-4.927c0,0,4.147.819,4.4,3.34A11.461,11.461,0,0,1,227.539,272.678Z",
    transform: "translate(-217.86 -261.851)",
    fill: "#fccca2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(28.974 14.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M219.188,274.94s.019-1.192.56-1.307,5.967-.636,6.631-.375v1.389S225.1,275.434,219.188,274.94Z",
    transform: "translate(-219.188 -273.186)",
    fill: "#e2d2ca"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    transform: "translate(29.152 5.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M219.468,267.253c.1-.424,1.179-1.636,1.592-.338s-.623,3.042-1.2,2.892S219.212,268.328,219.468,267.253Z",
    transform: "translate(-219.326 -266.332)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    transform: "translate(8.843 16.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M223.712,274.612s-2.976,1.069-6.422,2.535A7.23,7.23,0,0,0,212.9,283c-.228,2.323-2.7,14.656-3.167,15.7s-5.949,17.807-6.144,18.154,4.479,2.288,4.787,2.133,5.313-15.29,5.815-16.411c0,0,2.88-9.074,2.958-10.427,0,0,.083,3.855.237,4.938s-2.562,22.1-2.483,22.675,12.341,1.317,17.25.775a60.127,60.127,0,0,0,8.869-1.669s-3.862-16.584-3.745-18.422c.259-4.008,1.6-11.551,1.6-11.551l4,7.543-5.122,13.181,1.173,4.005s9.521-14.386,9.829-15.7-.466-2.989-.969-4.071-3.8-9.317-4.577-10.478-2.078-5.8-5.236-7.094a49.247,49.247,0,0,0-7.07-1.966Z",
    transform: "translate(-203.582 -274.319)",
    fill: "#77a7fb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(0 44.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 23.152,
    height: 16.152,
    transform: "translate(4.012) rotate(14.381)",
    fill: "#f25f54"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(5.979 62.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M202.279,309.95s-.642,1.034-.876,1.331.575.481.922.182S202.279,309.95,202.279,309.95Z",
    transform: "translate(-201.362 -309.95)",
    fill: "#c98462"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(6.846 58.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M206.754,314.334a2.487,2.487,0,0,0,.46-.647s.112-.473.213-.8c.034-.106.063-.2.088-.251a4.567,4.567,0,0,0,.513-1.363c.1-.639.379-3.509.379-3.509l-1.739-.438-1.394-.294s-3.016,3.008-3.177,3.594a1.656,1.656,0,0,0-.036.169,5.925,5.925,0,0,0,.043,1.2c-.005.1.01,1.1.243,1.283a.978.978,0,0,0,.922.222,2.316,2.316,0,0,0,1.2.45,1.448,1.448,0,0,0,1.258.234S206.373,314.578,206.754,314.334Z",
    transform: "translate(-202.033 -307.027)",
    fill: "#de9d7d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(8.849 45.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M213.085,299.033s-3.979,12.054-4.712,13.321a13.121,13.121,0,0,1-4.787-2.134l4.371-13.009Z",
    transform: "translate(-203.586 -297.212)",
    fill: "#63a4ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    transform: "translate(508.358 313.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(8.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M510.212,326.981s14.776-43.332-13.42-56.765-52.136,5.985-56.659,16.493-3.325,29.614.531,42.937,3.3,33.6-5.082,40.388-18.769,18.048-18.255,40.98c.32,14.228,55.983-36.392,55.983-36.392Z",
    transform: "translate(-417.309 -265.644)",
    fill: "#252e3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    transform: "translate(0 111.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M472.552,353.419s-23.174,5.136-32.374,10.513-29.626,30.1-29.626,40.736,89.336,20.566,89.336,20.566l16.932,61.817s45.154-11.018,50.529-20.157-17.149-74.634-21.006-87.889c-3.932-13.522-20.116-22.95-38.93-25.586A129.222,129.222,0,0,0,472.552,353.419Z",
    transform: "translate(-410.552 -352.248)",
    fill: "#ffd255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    transform: "translate(54.303 111.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M493.6,353.361s-.521,28.168-22.861,29-17.688-27.017-17.688-27.017S469.391,348.728,493.6,353.361Z",
    transform: "translate(-452.651 -351.715)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    transform: "translate(82.527 27.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M496.709,287.1s7.9,45.3-14.6,78.03C458.8,399.018,496.709,287.1,496.709,287.1Z",
    transform: "translate(-474.532 -287.095)",
    fill: "#252e3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(57.363 83.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M488.119,339.629s-1.553,13.474,1.041,21.854S455,370.092,455.023,363.2c.023-7.827,3.76-14.365.24-27.781S488.119,339.629,488.119,339.629Z",
    transform: "translate(-455.023 -330.383)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424",
    transform: "translate(61.951 94.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M458.58,338.883s11.6,12.089,26.442,1.261c0,0-1.225,7.727-11.9,8.725S458.58,338.883,458.58,338.883Z",
    transform: "translate(-458.58 -338.883)",
    fill: "#a77860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425",
    transform: "translate(43.879 11.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M477.174,275.05s29.324,8.677,25.135,49.375-23.339,38.6-25.135,38.9-24.538,1.8-31.72-47.579S477.174,275.05,477.174,275.05Z",
    transform: "translate(-444.569 -274.463)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    transform: "translate(41.75 8.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M470.082,293.759s15.934,25.348,32.706,31.229c0,0,9.158-42.533-28.664-51.445s-31.9,42.96-29.076,56.792C445.047,330.335,452.925,309.985,470.082,293.759Z",
    transform: "translate(-442.919 -272.52)",
    fill: "#252e3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    transform: "translate(47.541 7.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M447.408,290.351s8.387-16.244,22.551-16.97,22.588,11.563,22.588,11.563-5.53-13.836-22.569-13.836S447.408,290.351,447.408,290.351Z",
    transform: "translate(-447.408 -271.108)",
    fill: "#88c0ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(482.667 467.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M521.529,385.071l9.945,92.458H400.58l-9.945-92.458Z",
    transform: "translate(-390.635 -385.071)",
    fill: "#77a7fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(478.247 462.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M529.316,475.326H397.276l-10.068-93.6H519.25ZM398.3,474.186H528.046l-9.821-91.318H388.479Z",
    transform: "translate(-387.208 -381.726)",
    fill: "#5fa0ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(544.689 503.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M455.237,421.748c1.175,5.752-1.508,11.159-5.994,12.076s-9.073-3-10.248-8.755,1.508-11.159,5.992-12.076S454.06,416,455.237,421.748Z",
    transform: "translate(-438.718 -412.861)",
    fill: "#5189db"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(611.132 550.459)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 24.425,
    height: 9.294,
    transform: "translate(24.425 9.294) rotate(180)",
    fill: "#5fa0ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(515.05 241.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M435.877,250.585a20.137,20.137,0,1,1,20.137-20.138A20.159,20.159,0,0,1,435.877,250.585Zm0-39.133a19,19,0,1,0,18.995,19A19.018,19.018,0,0,0,435.877,211.452Z",
    transform: "translate(-415.74 -210.31)",
    fill: "#64a4ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434",
    transform: "translate(73.173 376.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M180.061,425.053l-.013-1.713c3.413-.029,6.854-.123,10.226-.281l.081,1.711C186.962,424.928,183.5,425.024,180.061,425.053Zm-10.3-.106c-3.382-.1-6.845-.253-10.29-.472l.107-1.708c3.426.217,6.869.374,10.231.47Zm30.872-.865-.15-1.705c3.38-.294,6.8-.661,10.173-1.09l.217,1.7C207.477,423.416,204.031,423.786,200.632,424.082Zm-51.431-.426c-3.511-.348-6.954-.795-10.229-1.329l.275-1.69c3.24.528,6.647.971,10.122,1.314Zm71.862-2.176-.284-1.69c3.3-.552,6.683-1.185,10.061-1.882l.344,1.678C227.786,420.286,224.382,420.922,221.063,421.48Zm-92.215-1.188c-3.45-.836-6.789-1.806-9.927-2.886l.557-1.617c3.085,1.059,6.375,2.015,9.774,2.838Zm112.384-2.95-.4-1.665c3.141-.753,6.39-1.578,9.931-2.52l.441,1.655C247.65,415.757,244.388,416.585,241.232,417.342Zm-131.9-3.836a74.7,74.7,0,0,1-9.036-5.089l.944-1.427a73.333,73.333,0,0,0,8.831,4.971Zm151.788-1.42-.463-1.647q2.15-.6,4.255-1.2,2.852-.807,5.629-1.587L271,409.3q-2.775.776-5.624,1.584Q263.267,411.481,261.117,412.086Zm89.243-1.431c-3.156-1.494-6.319-2.809-9.4-3.911l.577-1.612c3.135,1.121,6.35,2.457,9.556,3.975Zm-69.466-4.024-.424-1.659c3.687-.943,6.969-1.708,10.035-2.341l.347,1.677C287.811,404.935,284.553,405.7,280.893,406.631Zm50.315-2.759a80.012,80.012,0,0,0-10.017-1.659l.172-1.705A82.5,82.5,0,0,1,331.6,402.2Zm-30.3-1.265-.217-1.7A98.18,98.18,0,0,1,311,400.115l.037,1.711A96.831,96.831,0,0,0,300.9,402.606Zm-208.788-.6a57.4,57.4,0,0,1-6.955-7.734l1.374-1.023a55.793,55.793,0,0,0,6.746,7.5ZM79.742,385.39a60.543,60.543,0,0,1-3.743-9.7l1.643-.479a58.817,58.817,0,0,0,3.636,9.429Zm-5.872-19.875a81.857,81.857,0,0,1-.7-10.351l1.712-.01a80.371,80.371,0,0,0,.684,10.136Zm1.52-20.526-1.7-.174c.342-3.351.862-6.8,1.54-10.237l1.679.332C76.238,338.3,75.728,341.691,75.39,344.989ZM79.314,325l-1.646-.476a91.51,91.51,0,0,1,3.364-9.828l1.574.673A91.435,91.435,0,0,0,79.314,325Z",
    transform: "translate(-73.173 -314.692)",
    fill: "#c2bebc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435",
    transform: "translate(229.898 101.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M588.018,179.064c-.028-.026-2.888-2.564-8.008-6.371l1.022-1.374c5.187,3.857,8.1,6.44,8.125,6.466ZM571.633,166.8c-2.815-1.879-5.725-3.724-8.65-5.483l.884-1.467c2.947,1.772,5.879,3.632,8.718,5.526Zm-17.544-10.557c-3.008-1.623-6.078-3.183-9.122-4.642l.739-1.545c3.07,1.47,6.163,3.045,9.2,4.681Zm-18.461-8.831c-3.163-1.323-6.372-2.568-9.538-3.7l.575-1.612c3.2,1.142,6.431,2.4,9.623,3.733Zm-130.081-2.1-.039-1.712a72.363,72.363,0,0,0,10.1-.948l.277,1.69A73.994,73.994,0,0,1,405.547,145.312Zm-10.36-.533a76.4,76.4,0,0,1-10.179-2l.441-1.654a74.715,74.715,0,0,0,9.949,1.957Zm30.8-2.764-.482-1.642c1.1-.324,2.22-.677,3.33-1.05,2.14-.718,4.323-1.392,6.487-2l.464,1.648c-2.137.6-4.293,1.267-6.407,1.975C428.25,141.326,427.109,141.686,425.989,142.015Zm90.379-1.477c-3.287-.969-6.612-1.843-9.886-2.6l.384-1.668c3.307.765,6.666,1.649,9.985,2.628Zm-141.189-1c-3.014-1.176-6.106-2.536-9.452-4.157l.748-1.54c3.3,1.6,6.354,2.942,9.326,4.1Zm70.524-2.953-.335-1.678c3.356-.675,6.789-1.229,10.2-1.647l.208,1.7C452.409,135.37,449.02,135.915,445.7,136.582Zm50.756-.631c-3.373-.556-6.78-1-10.126-1.327l.165-1.7c3.383.328,6.829.78,10.239,1.343Zm-300.852-1.629-.933-1.437c2.933-1.9,5.87-3.739,8.729-5.463l.884,1.465C201.444,130.6,198.523,132.43,195.608,134.322Zm270.335-.224-.08-1.71c3.407-.16,6.871-.2,10.328-.1l-.044,1.71C472.731,133.9,469.308,133.939,465.942,134.1ZM356.57,130.642c-2.9-1.578-5.784-3.2-8.978-5l.841-1.491c3.189,1.8,6.063,3.418,8.954,4.989Zm-143.42-6.876-.828-1.5c3.069-1.694,6.139-3.306,9.125-4.789l.762,1.534C219.244,120.483,216.2,122.082,213.15,123.766Zm125.493-3.132c-3.351-1.838-6.315-3.4-9.059-4.767l.765-1.532c2.763,1.38,5.746,2.95,9.117,4.8Zm-107.167-5.943-.682-1.57c3.225-1.4,6.447-2.692,9.579-3.837l.588,1.609C237.861,112.025,234.67,113.3,231.476,114.691Zm88.839-3.116c-3.28-1.387-6.4-2.559-9.539-3.585l.531-1.628c3.186,1.041,6.35,2.23,9.676,3.636Zm-69.656-3.858-.473-1.646c3.374-.973,6.753-1.8,10.037-2.466l.338,1.678C257.322,105.937,253.991,106.756,250.659,107.717Zm50.3-2.407a93.528,93.528,0,0,0-10.03-1.632l.182-1.7a94.873,94.873,0,0,1,10.215,1.663Zm-30.336-1.588-.183-1.7a100.991,100.991,0,0,1,10.337-.575l.005,1.713A98.28,98.28,0,0,0,270.627,103.722Z",
    transform: "translate(-194.675 -101.444)",
    fill: "#c2bebc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(366.903 474.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M343.918,407.337l-43.03-12.511,12.9-3.89Z",
    transform: "translate(-300.888 -390.936)",
    fill: "#d6d6d6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    transform: "translate(17.047 0.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M340.087,407.282,324,391.128l-9.9,2.01Z",
    transform: "translate(-314.104 -391.128)",
    fill: "#e8e8e8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444",
    transform: "translate(9.896 6.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M308.56,396.181l.346,4.979,32.788,4.656Z",
    transform: "translate(-308.56 -396.181)",
    fill: "#c2c2c2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    transform: "translate(193.357 140.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M166.346,153.959l37.93-21.213-13.038-.86Z",
    transform: "translate(-166.346 -131.886)",
    fill: "#d6d6d6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451",
    transform: "translate(0 3.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M166.346,153.277,178.018,134.5l9.794-.261Z",
    transform: "translate(-166.346 -134.242)",
    fill: "#e8e8e8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454",
    transform: "translate(0 5.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M195.553,136.335l.76,4.78L166.346,152.67Z",
    transform: "translate(-166.346 -136.335)",
    fill: "#c2c2c2"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.ceb21fefd9aaa9e4735fedc6315de95a.svg";
export { ForwardRef as ReactComponent };